import React, { useEffect, useState, createContext,useContext, ReactNode } from "react";
import {
  withRouter,
  RouteComponentProps,
  useHistory,
  Link,
  useLocation,
} from "react-router-dom";
import {
  Grid,
  GridList,
  GridListTile,
  Paper,
  List,
  ListItem,
} from "@material-ui/core";
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { makeStyles } from "@material-ui/core/styles";
import { RBShiftLayoutCard } from "../../components/RBShiftLayoutCard";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { Colors, Spacing } from "../../theme/Theme";
import { ApprovalModeEnum, RoutePathConstant, roleNameEnum } from "../../util/Common";
import { RBPopover } from "../../components/RBPopOver";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { ShiftListContext } from "../../components/ShiftListContext";
import { ShiftRelatedConstants } from "../../util/ShiftConstants";
import { ShiftService } from "../../api/ShiftService";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { useLastLocation } from "react-router-last-location";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum } from "../../api/constants";
import { AuthService } from "../../api/AuthService";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { RBCardView } from "../../components/RBCardView";
import moment from "moment-timezone";
import { formatWorkerType } from "../../util/FormattingService";
import { RBTextField } from "../../components/RBTextField";
import { PharmacyService } from "../../api/PharmacyService";
import { LocationApplicantsPage } from "../LocationApplicants/LocationApplicantsPage";
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import ShiftPaymentModal from "../../components/ShiftPaymentModal";
import { getRequestPaymentDisableInfo } from "../../util/RequestPaymentReminder";
import { dateOnlyToUtcIso } from "../../util/DatetimeUtils";
import {
  getPaymentInfoAvailability,
  isPaymentInfoNotApplicable,
} from "../../util/PaymentInfoAvailability";
import { useStripePaymentRefresh } from "../../util/useStripePaymentRefresh";
import {
  ShiftListUiStateCarrier,
  withShiftListUiState,
} from "../../util/shiftListUiState";
import { AccountInfoContext } from "../../components/AccountInfoContext";


interface ShiftListPageWithoutRouteProps extends RouteComponentProps<any> {
  shifts?: ShiftProps[];
  roleName: string;
  applicants?: any;
  pharmacy?: any;
  userId?: string;
  shiftState?:number;
}

type ShiftListPageLocationState = ShiftListUiStateCarrier & {
  selectedShiftId?: string;
};


const ShiftListPageWithoutRoute: React.FC<ShiftListPageWithoutRouteProps> = ({
  history,
  match,
  ...props
}) => {
  const { shifts, roleName ,applicants, pharmacy,userId,shiftState} = props;
  // 
  const {industryMode, primaryColor,secondaryColor,updateprimaryColor,updateSecondaryColor,updateContactEmail,updateContactPhone,updateMode, contactEmail } = useContext(RBContext);

  const [isAlertShowing, setShiftAlertShowing] = useState(false);
  const [shiftAlertInfo, setShiftAlertInfo] = useState<AlertInfoProps>({});
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isButtonNoLoading, setIsButtonNoLoading] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const location = useLocation<ShiftListPageLocationState>();
  const lastLocation = useLastLocation();
  const [account, setAccount] = useState<any>([]);

  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [paymentShift, setPaymentShift] = useState<ShiftProps | null>(null);
  const [stripePaymentShiftId, setStripePaymentShiftId] = useState<string | null>(null);

  const [blockUserDialogVisible, setBlockUserDialogVisible] = useState(false);
  const [blockUserComment, setBlockUserComment] = useState('');
  const [activeShift, setActiveShift] = useState<any>(null);
  const [loadingShiftId, setLoadingShiftId] = useState<string | null>(null);

  const { accountInformation } = useContext(AccountInfoContext);

  // Hook for auto-refresh after Stripe payment
  // ShiftListController subscribes to NotificationService.ShiftChanged, so we just need to publish
  const { startStripePaymentWatch, stopStripePaymentWatch } = useStripePaymentRefresh({
    shiftId: stripePaymentShiftId || undefined,
  });

console.log("shifts in shift list page ", shifts);
  const openPaymentModal = (shift: ShiftProps) => {
    setPaymentShift(shift);
    setPaymentModalVisible(true);
  };

  const closePaymentModal = () => {
    setPaymentModalVisible(false);
    setPaymentShift(null);
  };

  const formatPaymentErrorMessage = (err: any): string => {
    const payload = err?.response?.data;

    if (typeof payload?.message === "string") return payload.message;
    if (typeof payload?.error === "string") return payload.error;

    if (Array.isArray(payload?.message)) {
      const firstMessage = payload.message[0];
      if (typeof firstMessage === "string") {
        return firstMessage;
      }
      if (firstMessage && typeof firstMessage === "object") {
        const constraints = (firstMessage as any).constraints;
        if (constraints && typeof constraints === "object") {
          const values = Object.values(constraints).filter(
            (value) => typeof value === "string"
          ) as string[];
          if (values.length > 0) {
            return values[0];
          }
        }
      }
      return "Unable to process payment at this time.";
    }

    if (payload && typeof payload === "object") {
      if (typeof payload.target === "string") return payload.target;
      return "Unable to process payment at this time.";
    }

    if (typeof payload === "string") return payload;
    if (typeof err?.message === "string") return err.message;
    return "Unable to process payment at this time.";
  };

  const handleCreatePayment = async (payload: any) => {
    try {
      setIsButtonLoading(true);
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        // Save shift ID before closing modal so refresh hook can use it
        setStripePaymentShiftId(paymentShift.id as string);
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        setIsButtonLoading(false);
        return;
      }

      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: dateOnlyToUtcIso(payload.paymentDate),
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.createShiftPayment(body);

      setPaymentModalVisible(false);
      setShiftAlertInfo({
        title: "Success",
        message: "Shift payment details saved.",
        buttons: [
          <RBButton
            key={"okPayment"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        paymentShift.id
      );
    } catch (err) {
      const e: any = err;
      setShiftAlertInfo({
        title: "Error",
          message: formatPaymentErrorMessage(e),
        buttons: [
          <RBButton
            key={"okErrPayment"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const handleUpdatePayment = async (payload: any) => {
    try {
      setIsButtonLoading(true);
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment update");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        // Save shift ID before closing modal so refresh hook can use it
        setStripePaymentShiftId(paymentShift.id as string);
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        setIsButtonLoading(false);
        return;
      }

      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: dateOnlyToUtcIso(payload.paymentDate),
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.updateShiftPayment(paymentShift.id as string, body);

      setPaymentModalVisible(false);
      setShiftAlertInfo({
        title: "Success",
        message: "Shift payment details updated.",
        buttons: [
          <RBButton
            key={"okPaymentUpdate"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        paymentShift.id
      );
    } catch (err) {
      const e: any = err;
      setShiftAlertInfo({
        title: "Error",
          message: formatPaymentErrorMessage(e),
        buttons: [
          <RBButton
            key={"okErrPaymentUpdate"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const requestPaymentForShift = async (shiftData: ShiftProps) => {
    try {
      const disableInfo = getRequestPaymentDisableInfo(shiftData);
      if (disableInfo.disabled) {
        setShiftAlertInfo({
          title: "Request Payment",
          message: disableInfo.reason || "You cannot request payment right now.",
          buttons: [
            <RBButton
              key={"okRequestPaymentDisabled"}
              onClick={() => setShiftAlertShowing(false)}
              buttonBackgroundColor={secondaryColor}
                text="Ok"
            />,
          ],
        });
        setShiftAlertShowing(true);
        return;
      }

      setIsButtonLoading(true);
      await ShiftService.requestShiftPayment(shiftData.id as string);

      const locationName =
        shiftData?.pharmacy?.displayName ||
        shiftData?.pharmacy?.name ||
        (shiftData as any)?.location ||
        "Location";

      setShiftAlertInfo({
        title: "Request Payment",
        message: `Your request has been emailed to ${locationName}`,
        buttons: [
          <RBButton
            key={"okRequestPayment"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        shiftData.id
      );
    } catch (err) {
      const e: any = err;
      setShiftAlertInfo({
        title: "Error",
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.response?.data ||
          e?.message,
        buttons: [
          <RBButton
            key={"okErrRequestPayment"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const showRequestPaymentDisabledAlert = (shiftData: ShiftProps) => {
    const disableInfo = getRequestPaymentDisableInfo(shiftData);
    if (!disableInfo.disabled) return false;

    setShiftAlertInfo({
      title: "Request Payment",
      message: disableInfo.reason || "You cannot request payment right now.",
      buttons: [
        <RBButton
          key={"okRequestPaymentDisabled"}
          onClick={() => setShiftAlertShowing(false)}
          buttonBackgroundColor={secondaryColor}
          text="Ok"
        />,
      ],
    });
    setShiftAlertShowing(true);
    return true;
  };


  // when there is a need to talk to API
  const onActionRelatedToAPI = async (buttonText: string, shiftId: string) => {
    try {
      setShiftAlertShowing(false);
      setIsButtonLoading(true);

      if (roleName === roleNameEnum.owner) {
        switch (buttonText) {
          case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
            await ShiftService.cancelShiftById(shiftId);
            break;
          }
        }
      } else if (roleName === roleNameEnum.pharmacist) {
        switch (buttonText) {
          case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
            await ShiftService.cancelShiftById(shiftId);
            break;
          }
          case ShiftRelatedConstants.ShiftButtonText.WithdrawShift: {
            console.log("worker  WithdrawShift");
            await ShiftService.withdrawRequestedShiftById(shiftId);
            break;
          }
        }
      }
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        shiftId
      );
    } catch (err) {
      const error = err as any;
      setSubmitErrorMessage(
        error && error.response ? error.response.data : error && error.message
      );
      console.log("onActionRelatedToAPI error ", error);
    } finally {
      console.log("onActionRelatedToAPI finally ");
      setIsButtonLoading(false);
    }
  };
  const setAlertState = (newState:any) => {
    setShiftAlertShowing(newState.isAlertShowing);
    setShiftAlertInfo(newState.alertInfo);
  };
   useEffect(() => {

    // Instant Invoke Function
    (async () => {
      await updateprimaryColor( localStorage.getItem('primaryColor')); 
      await updateSecondaryColor( localStorage.getItem('secondaryColor')); 
      await updateContactEmail( localStorage.getItem('contactEmail')); 
      await updateContactPhone( localStorage.getItem('contactPhone')); 
      await updateMode(localStorage.getItem('industryMode')); 

      const userData = await accountInformation;
      setAccount(userData);

    })(); 
  
    console.log("shift list last location ", lastLocation);
    if (lastLocation?.state) {
      const item = document.querySelector(
        ".restore-" +
          (lastLocation?.state as { shiftId?: string; scrollY?: number })
            .shiftId
      );

      if (item) {
        console.log("item1", item);
        //  item.scrollIntoView({ block: "center" });
        //  item.scrollIntoView();
        //      item.scrollBy({ top: -70 });
        const scrollY =
          (lastLocation?.state as {
            shiftId?: string;
            scrollY?: number;
          }).scrollY ?? 0;
        // window.scrollTo({
        //   top: (lastLocation?.state as { shiftId?: string; scrollY?: number })
        //     .scrollY,
        //   behavior: "smooth",
        // });
        window.scrollTo(555.5, scrollY);
        console.log("item exist pharmacy ");
      } else {
        console.log(`item does not exist`);
        window.scrollTo(200, 0);
      }
    }
  }, []);

  
  
   
  const OnShiftListButtonClick = (buttonText: string, shiftData: any) => {
    
    console.log("OnShiftListButtonClick ", buttonText, shiftData);
    const paymentInfoNotApplicable = isPaymentInfoNotApplicable(shiftData);
    const paymentInfo = paymentInfoNotApplicable
      ? getPaymentInfoAvailability(shiftData)
      : null;

    if (roleName === roleNameEnum.owner) {
     setLoadingShiftId(shiftData.id);
      switch (buttonText) {
        case ShiftRelatedConstants.ShiftButtonText.ViewApplications:
          if (shiftData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold) {
            showOnHoldAlert({
              setAlertState,
              primaryColor,
              contactEmail,
            });
          }else{
            history.push(RoutePathConstant.ViewApplicant + shiftData.id);
          }
            setLoadingShiftId(null)
          break;
        case ShiftRelatedConstants.ShiftButtonText.ConfirmHours:
          history.push(RoutePathConstant.ShiftConfirmHour + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.RateShift:
          history.push(RoutePathConstant.ShiftSurvey + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.EditShift:
          if (shiftData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold) {
            showOnHoldAlert({
              setAlertState,
              primaryColor,
              contactEmail,
            });
          } else {
            history.push(`${RoutePathConstant.ShiftDetail}${shiftData.id}`, {
              shiftId: shiftData.id,
              scrollY: window.scrollY,
            })
          }
            setLoadingShiftId(null)
          //industryMode === IndustryModeEnum.Pharmaceutical ? history.push(RoutePathConstant.EditShift + shiftData.id) : history.push(RoutePathConstant.EditeDentalShift + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.FeedbackShift:
          setBlockUserDialogVisible(true);
          setActiveShift(shiftData)
          break;

        case ShiftRelatedConstants.ShiftButtonText.MarkPaid:
          if (paymentInfoNotApplicable) {
            setShiftAlertInfo({
              title: "Payment Info",
              message:
                paymentInfo?.tooltip ||
                "Payment info is not available for this shift.",
              buttons: [
                <RBButton
                  key={"okPaymentInfoNotApplicableListOwner"}
                  onClick={() => setShiftAlertShowing(false)}
                  buttonBackgroundColor={secondaryColor}
                  text="Ok"
                />,
              ],
            });
            setShiftAlertShowing(true);
            break;
          }
          openPaymentModal(shiftData);
          break;

        case ShiftRelatedConstants.ShiftButtonText.RequestPayment:
          if (paymentInfoNotApplicable) {
            setShiftAlertInfo({
              title: "Request Payment",
              message:
                paymentInfo?.tooltip ||
                "Request Payment is not available for this shift.",
              buttons: [
                <RBButton
                  key={"okPaymentInfoNotApplicableRequestListOwner"}
                  onClick={() => setShiftAlertShowing(false)}
                  buttonBackgroundColor={secondaryColor}
                  text="Ok"
                />,
              ],
            });
            setShiftAlertShowing(true);
            break;
          }
          if (showRequestPaymentDisabledAlert(shiftData)) {
            break;
          }
          setShiftAlertInfo({
            title: "Request Payment",
            message:
              "Are you sure you want to send the request payment message?",
            buttons: [
              <RBButton
                key={"confirmRequestPaymentOwner"}
                isLoading={isButtonLoading}
                onClick={async () => {
                  setShiftAlertShowing(false);
                  await requestPaymentForShift(shiftData);
                }}
                buttonBackgroundColor={primaryColor}
                text="Yes"
              />,
              <RBButton
                key={"cancelRequestPaymentOwner"}
                buttonType={RBButtonType.cancel}
                onClick={() => {
                  setShiftAlertShowing(false);
                }}
                text="Cancel"
              />,
            ],
          });
          setShiftAlertShowing(true);
          break;
          
      }
    } else if (roleName === roleNameEnum.pharmacist) {
      switch (buttonText) {
        case ShiftRelatedConstants.ShiftButtonText.ConfirmHours:
          history.push(
            RoutePathConstant.ShiftConfirmHour + shiftData.id,
            withShiftListUiState(location.state?.shiftListUiState)
          );
          break;

        case ShiftRelatedConstants.ShiftButtonText.WithdrawShift: {
            setShiftAlertInfo({
              title: "Withdraw from Shift",
              message: "Are you sure you wish to withdraw from this shift?",
              buttons: [
                <RBButton
                  key={"confirm"}
                  onClick={async () => {
                    await onActionRelatedToAPI(
                      ShiftRelatedConstants.ShiftButtonText.WithdrawShift,
                      shiftData.id
                    );
                  }}
                  buttonBackgroundColor={primaryColor}
                  color="primary"
                  text="Yes"
                />,
                <RBButton
                  key={"cancel"}
                  buttonType={RBButtonType.cancel}
                  onClick={() => {
                    setShiftAlertShowing(false);
                  }}
                  text="No"
                />,

              ],
            });
            setShiftAlertShowing(true);
            break;
        }
        case ShiftRelatedConstants.ShiftButtonText.FeedbackShift:
          setBlockUserDialogVisible(true);
          setActiveShift(shiftData)
          break;
        case ShiftRelatedConstants.ShiftButtonText.RateShift:
          history.push(
            RoutePathConstant.ShiftSurvey + shiftData.id,
            withShiftListUiState(location.state?.shiftListUiState)
          );
           break;
        case ShiftRelatedConstants.ShiftButtonText.MarkPaid:
          if (paymentInfoNotApplicable) {
            setShiftAlertInfo({
              title: "Payment Info",
              message:
                paymentInfo?.tooltip ||
                "Payment info is not available for this shift.",
              buttons: [
                <RBButton
                  key={"okPaymentInfoNotApplicableListWorker"}
                  onClick={() => setShiftAlertShowing(false)}
                  buttonBackgroundColor={secondaryColor}
                  text="Ok"
                />,
              ],
            });
            setShiftAlertShowing(true);
            break;
          }
          openPaymentModal(shiftData);
          break;

        case ShiftRelatedConstants.ShiftButtonText.RequestPayment:
          if (paymentInfoNotApplicable) {
            setShiftAlertInfo({
              title: "Request Payment",
              message:
                paymentInfo?.tooltip ||
                "Request Payment is not available for this shift.",
              buttons: [
                <RBButton
                  key={"okPaymentInfoNotApplicableRequestListWorker"}
                  onClick={() => setShiftAlertShowing(false)}
                  buttonBackgroundColor={secondaryColor}
                  text="Ok"
                />,
              ],
            });
            setShiftAlertShowing(true);
            break;
          }
          if (showRequestPaymentDisabledAlert(shiftData)) {
            break;
          }
          setShiftAlertInfo({
            title: "Request Payment",
            message:
              "Are you sure you want to send the request payment message?",
            buttons: [
              <RBButton
                key={"confirmRequestPaymentWorker"}
                isLoading={isButtonLoading}
                onClick={async () => {
                  setShiftAlertShowing(false);
                  await requestPaymentForShift(shiftData);
                }}
                buttonBackgroundColor={primaryColor}
                text="Yes"
              />,
              <RBButton
                key={"cancelRequestPaymentWorker"}
                buttonType={RBButtonType.cancel}
                onClick={() => {
                  setShiftAlertShowing(false);
                }}
                text="Cancel"
              />,
            ],
          });
          setShiftAlertShowing(true);
        
      }
    }
  };

  const onClickShiftCard = (shiftId: string) => {
    const item = document.querySelector(".restore-" + shiftId);

    history.push(`${RoutePathConstant.ShiftDetail}${shiftId}`, {
      shiftId: shiftId,
      scrollY: window.scrollY,
      ...withShiftListUiState(location.state?.shiftListUiState),
    });
    console.log(
      "shift onClickShiftCard id ",
      shiftId,
      window.scrollY,
      item?.getBoundingClientRect()
    );
  };
  // const onBackButtonEvent = (e: any) => {
  //   console.log("shift list onBackButtonEvent", e);
  //   console.log("shift list onBackButtonEvent location state", location);
  // };
  //window.onpopstate = onBackButtonEvent;

 
  const onClose = () => {
    setBlockUserDialogVisible(false);
    setActiveShift(null)
  }

  const  onBlockUser = async (shiftData:any) => {
    try {
      setIsButtonNoLoading(true)
      await AuthService.blockUser({
        comment: blockUserComment.length > 0 ? blockUserComment : null,
        shiftId: shiftData.id,
      });
      let payload = {};
      if(roleName === roleNameEnum.owner)
      {
        payload = {
          id: shiftData.id,
          locationFeedbackGiven: true
        }
      }else{
        payload = {
          id: shiftData.id,
          workerFeedbackGiven: true
        }
      }
      await PharmacyService.updateShiftFeedback(payload)
      setIsButtonNoLoading(false)
    } catch (error) {
      setIsButtonNoLoading(false)
      console.log('onBlockUser ', error);
    }

    setBlockUserDialogVisible(false);
    history.goBack();
  };

  const  onShiftFeedback = async (shiftData:any) => {
    try {
      setIsButtonLoading(true);
      let payload = {};
      if(roleName === roleNameEnum.owner)
      {
        payload = {
          id: shiftData.id,
          locationFeedbackGiven: true
        }
      }else{
        payload = {
          id: shiftData.id,
          workerFeedbackGiven: true
        }
      }
      await PharmacyService.updateShiftFeedback(payload)
      setIsButtonLoading(false);
    } catch (error) {
      setIsButtonLoading(false);
      console.log('onBlockUser ', error);
    }

    setBlockUserDialogVisible(false);
    history.goBack();
  };

  const renderCreateShiftContent = (shiftData:any) => {
    console.log("shiftData",shiftData)
    if (roleName === roleNameEnum.owner)
    {
      return (
        <div
          style={{
            backgroundColor: Colors.defaultGrey,
            display: "flex",
            flex: 1,
          }}
        >
          
            <RBCardView
              style={{
                flex: 1,
                marginLeft: Spacing.large,
                marginRight: Spacing.large,
                marginBottom: Spacing.smallest,
                paddingLeft: Spacing.large,
                paddingTop: Spacing.large,
                paddingRight: Spacing.large,
                paddingBottom: Spacing.large,
              }}
            >
            <div>
              How did the shift go with {shiftData?.pharmacist?.pharmacist?.firstName} {shiftData?.pharmacist?.pharmacist?.lastName}?
              Would you consider hiring this {formatWorkerType(shiftData.pharmacistType)} again?
            </div>
            <br></br>
            <div>
              <RBTextField
                style={{
                  display: "flex",
                  flex: 1,
                  paddingTop: Spacing.small,
                  paddingBottom: Spacing.small,
                }}
                placeholder={"*Please leave a comment if you decide no."}
                value={blockUserComment}
                onChange={(event) => setBlockUserComment(event.target.value)}
                multiline
                rows={3}
                rowsMax={8}
              />
            </div>
            <br></br>
            <div style={{color:'red'}}>
              *If you select "No", this {formatWorkerType(shiftData.pharmacistType)} will not be matched with any future shifts/jobs you
                post for this office or any of the other offices on your profile.
            </div>
            <div style={{
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}>
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    isLoading={isButtonNoLoading}
                    disabled={blockUserComment.length === 0 || isButtonLoading}
                    text="No"
                    onClick={() => onBlockUser(shiftData)}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                    }}
                  />
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    isLoading={isButtonLoading}
                    disabled={isButtonNoLoading}
                    text="Yes"
                    onClick={() => onShiftFeedback(shiftData)}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                    }}
                  />
            </div>
            </RBCardView>
        
        </div>
      );
    }
    else{
      return (
        <div
          style={{
            backgroundColor: Colors.defaultGrey,
            display: "flex",
            flex: 1,
          }}
        >
          
            <RBCardView
              style={{
                flex: 1,
                marginLeft: Spacing.large,
                marginRight: Spacing.large,
                marginBottom: Spacing.smallest,
                paddingLeft: Spacing.large,
                paddingTop: Spacing.large,
                paddingRight: Spacing.large,
                paddingBottom: Spacing.large,
              }}
            >
             <div>
             How did your shift go with {shiftData.pharmacy.name}? Would you consider
              working at this {shiftData.pharmacy.companyType} again?
             </div>
             <br></br>
             <div>
              <RBTextField
                style={{
                  display: "flex",
                  flex: 1,
                  paddingTop: Spacing.small,
                  paddingBottom: Spacing.small,
                }}
                placeholder={"*Please leave a comment if you decide no."}
                value={blockUserComment}
                onChange={(event) => setBlockUserComment(event.target.value)}
                multiline
                rows={3}
                rowsMax={8}
              />
             </div>
             <br></br>
             <div style={{color:'red'}}>
             *If you select "No", you will never match with that {industryMode === IndustryModeEnum.Dentistry ? "dental practice's " : "companies "}
              shifts/jobs again.
             </div>
             <div
             style={{
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}>
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    isLoading={isButtonLoading}
                    disabled={blockUserComment.length === 0}
                    text="No"
                    onClick={() => onBlockUser(shiftData)}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                    }}
                  />
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    isLoading={isButtonLoading}
                    text="Yes"
                    onClick={() => onShiftFeedback(shiftData)}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                    }}
                  />
             </div>
            </RBCardView>
         
        </div>
      );
    }
  };
  
  const renderBlockUserDialog = (shift:any) => {
    
    return (

      <RBModal
          open={blockUserDialogVisible}
          onClose={onClose}
          modalTitle={"Shift Feedback"
          }
          header={
                     <RBEmptyBlock
                       style={{
                         width: "100%",
                         height: Spacing.large,
                         backgroundColor: Colors.defaultGrey,
                         flexShrink: 0,
                       }}
                     />
                   }
         // actions={this.renderCreateShiftActions()}
          children={
              renderCreateShiftContent(shift)
          }
        />

    );
  };

  return (
    <>

      <ShiftPaymentModal
        open={paymentModalVisible}
        onClose={closePaymentModal}
        shift={paymentShift}
        existingPayment={paymentShift?.paymentData}
        currentUser={account}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        onCreate={handleCreatePayment}
        onUpdate={handleUpdatePayment}
      />
     
      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />
      <RBAlert
        show={isAlertShowing}
        alertTitle={shiftAlertInfo?.title}
        alertMessage={shiftAlertInfo?.message}
        buttons={shiftAlertInfo?.buttons}
      />
      <ShiftListContext.Provider
        value={{
          onAction: OnShiftListButtonClick,
          loadingShiftId: loadingShiftId,
        }}
      >
        <div style={{ paddingTop: Spacing.large }}>
          {shifts?.map((shift: ShiftProps) => (
            <div key={shift.id} className={`restore-${shift.id}`}>
              <RBShiftLayoutCard
                shift={shift}
                onClick={onClickShiftCard}
                rolename={roleName}
                account = {account}
                userId={userId}
                shiftState={shiftState}
              />
            </div>
          ))}
          {activeShift && renderBlockUserDialog(activeShift)}
          {applicants !== undefined && applicants.length > 0 &&
              <LocationApplicantsPage applicants={applicants} pharmacy={pharmacy}/>
          }
        </div>
      </ShiftListContext.Provider>
    </>
  );
};

export const ShiftListPage = withRouter(ShiftListPageWithoutRoute);
